import $ from 'jquery';
import Swiper, { Navigation, Thumbs, Pagination, Zoom } from 'swiper';
/**
 * @description Activate product image gallery
 */ export const init = async function() {
    const sections = $('.js-product-gallery-mobile');
    sections.each(function(_, sElement) {
        const section = $(sElement);
        const imageCarousel = section.find('.js-product-gallery-images-mobile');
        const imageSwiperContainerElement = imageCarousel.find('.swiper-container').first().get(0);
        if (!imageSwiperContainerElement) {
            return;
        }
        const imageSwiper = new Swiper(imageSwiperContainerElement, {
            autoHeight: false,
            direction: 'horizontal',
            init: false,
            loop: false,
            slidesPerView: 1,
            modules: [
                Navigation,
                Thumbs,
                Pagination,
                Zoom
            ],
            zoom: {
                maxRatio: 3,
                minRatio: 1
            },
            centerInsufficientSlides: false,
            centeredSlides: false,
            pagination: {
                el: '.js-pagination-mobile'
            },
            breakpoints: {
                1024: {
                    direction: 'vertical'
                }
            }
        });
        imageSwiper.init();
        const swiperSlide = document.getElementsByClassName('js-m-slide');
        for(let index = 0; index < swiperSlide.length; index++){
            var _swiperSlide_index;
            (_swiperSlide_index = swiperSlide[index]) === null || _swiperSlide_index === void 0 ? void 0 : _swiperSlide_index.addEventListener('click', function() {
                var _swiperSlide_index;
                const swiperZoomSlideClass = (_swiperSlide_index = swiperSlide[index]) === null || _swiperSlide_index === void 0 ? void 0 : _swiperSlide_index.classList;
                if (!(swiperZoomSlideClass === null || swiperZoomSlideClass === void 0 ? void 0 : swiperZoomSlideClass.contains('swiper-slide-zoomed'))) {
                    Shopify.analytics.publish('zoom_click', {
                        event: 'Zoom Click'
                    });
                }
                imageSwiper.zoom.toggle();
            });
        }
        let abTestInterval = null;
        const filterImagesByVariation = (key)=>{
            const hasImages = document.querySelector(`[data-ab-variation="${key}"]`) !== null;
            if (!hasImages) {
                return;
            }
            Array.from(imageSwiper.slides).forEach((slide)=>{
                if (slide.getAttribute('data-ab-variation') !== `${key}`) {
                    slide.remove();
                } else {
                    slide.setAttribute('data-is-slide-hidden', 'false');
                }
            });
            imageSwiper.update();
        };
        function checkImageABTest() {
            const abTestVariation = document.body.getAttribute('data-images-variation');
            if (abTestVariation) {
                abTestInterval && clearInterval(abTestInterval);
                if (abTestVariation === 'studio') {
                    filterImagesByVariation('STUDIO');
                }
                if (abTestVariation === 'lifestyle') {
                    filterImagesByVariation('STUDIO_LIFESTYLE');
                }
            }
        }
        abTestInterval = setInterval(checkImageABTest, 100);
    });
};
